import { useState } from "react";

const WHATSAPP_NUMBER = "85256803868";
const WHATSAPP_MESSAGE = "Hello Nice Accounting, I would like to enquire about your services.";

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 cursor-pointer group"
    >
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 bg-[#1C2331] text-white text-xs font-semibold px-4 py-2.5 rounded-full whitespace-nowrap shadow-lg ${
          hovered ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 pointer-events-none"
        }`}
      >
        Chat with us on WhatsApp
        <span className="absolute right-[-5px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-[5px] border-t-transparent border-b-[5px] border-b-transparent border-l-[5px] border-l-[#1C2331]" />
      </div>

      {/* Button */}
      <div className="relative w-14 h-14 flex items-center justify-center">
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping" />
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-20 scale-110 animate-ping [animation-delay:0.3s]" />

        {/* Main button */}
        <div className="relative w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] hover:bg-[#1fba57] transition-colors">
          <i className="ri-whatsapp-line text-white text-2xl" />
        </div>
      </div>
    </a>
  );
}
